import { cn } from '@/lib/utils'

export function CertificationRibbon({ className }: { className?: string }) {
	return (
		<div className={cn('bg-green-20 p-3 flex justify-center items-center', className)}>
			<a href="https://www.halborn.com/audits/pepper/pepper" target="_blank">
				<img
					src="/images/audited-by-halborn.webp"
					alt="Certified by Halborn"
					loading="lazy"
					className="aspect-[10/1] object-contain h-5"
				/>
			</a>
		</div>
	)
}
